import React, { useState } from "react";
import "../css/Faqs.css";

const faqsData = [
  {
    q: "Do I need prior fitness experience to join?",
    a: "No. Our programs are designed to adapt to your current level. Whether you’re starting fresh or returning after a break, training is scaled to your capacity."
  },
  {
    q: "How are workouts structured?",
    a: "Workouts follow progressive blocks that balance strength, mobility, and recovery. The focus is long-term sustainability rather than short-term intensity."
  },
  {
    q: "Can I train at my own pace?",
    a: "Yes. You’re encouraged to move with control and intention. Rest, recovery, and pacing are built into every program."
  },
  {
    q: "Are trainers available for guidance?",
    a: "Trainers are present throughout sessions to assist with form, technique, and adjustments. One-on-one coaching is also available in select plans."
  },
  {
    q: "What makes this gym different?",
    a: "We prioritize quality of movement, consistency, and balance over burnout-driven training. The goal is to build strength that lasts."
  }
];

const Faqs = () => {
  const [active, setActive] = useState(null);

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <div className="faqs6">

      {/* ================= HERO ================= */}
      <section className="f6-hero">
        <h1>Questions & Answers</h1>
        <p>Clear guidance. Honest responses.</p>
      </section>

      {/* ================= FAQ LIST ================= */}
      <section className="f6-list">
        {faqsData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${active === index ? "open" : ""}`}
            onClick={() => toggle(index)}
          >
            <div className="faq-question">
              <h3>{item.q}</h3>
              <span>{active === index ? "—" : "+"}</span>
            </div>

            <div className="faq-answer">
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </section>

    </div>
  );
};

export default Faqs;
